import React from "react";
import StateTaxOregonView from "./StateTaxOregonView";

export default function StateTaxRedmondView(props) {
  return <StateTaxOregonView {...props} />;
}
